import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import Loader from "../../commonComponent/Loader";
import {
  filterSoftDeletedClient,
  showToastError,
  showToastSuccess,
  sortByName,
} from "../../Utils/Helper";
import { assignPatientProvider } from "../../services/CareTeam";
import { getMyAssignedPatientList, getPatientList } from "../../services/PatientService";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import ApiConfig from "../../config/ApiConfig";
import { useAuth } from "../../Context/AuthContext";

const AssignPatientProviderModal = ({
  getAllProviders,
  provider,
  members,
  modalOpen,
  setModalOpen,
}) => {
  const { isAdmin } = useAuth();
  const [providerId, setProviderId] = useState(members);
  const [removePatientsModal, setRemovePatientsModal] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [filterdata, setFilterData] = useState([]);
  const [isLoading, setLoader] = useState(true);
  const [selectedPatientList, setSelectedPatientList] = useState([]);
  const urlPattern = new RegExp(
    "((http|https)://)(www.)?" +
      "[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]" +
      "{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)"
  );

  const getPatientsLists = async () => {
    try {
      let assignedPatientResponse;
      let allPatientResponse;

      // Assuming isAdmin is a boolean indicating whether the user is an admin
      if (!isAdmin) {
        assignedPatientResponse = await getMyAssignedPatientList();
      }
      allPatientResponse = await getPatientList();

      

      if (allPatientResponse.status === 200) {
        const assignedPatientData = assignedPatientResponse?.data?.data || [];
        const allPatientData = allPatientResponse?.data?.data || [];
        const combinedData = [...allPatientData];

        if (assignedPatientData.length > 0) {
          combinedData.push(...assignedPatientData);
        }

        let sortedData = sortByName(combinedData);

        setPatientList(sortedData);
        setFilterData(sortedData);
        setLoader(false);
        // Additional logic here if needed
        // props.onselectpatient(sortedData[sortedData.length - 1]);
        // dispatch(setPatientList(sortedData.reverse()));
      } else {
        showToastError(allPatientResponse?.data || allPatientResponse.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const UpdateGroup = (checked, id) => {
    if (checked) {
      // Checkbox is checked, add the patient to the selectedPatientList
      setSelectedPatientList((prevList) => [...prevList, id]);
    } else {
      // Checkbox is unchecked, filter out the patient with the specified id
      setSelectedPatientList((prevList) =>
        prevList.filter((patientId) => patientId !== id)
      );
    }
  };

  const updateGroup = async () => {
    try {
      let payload = {
        providerId: providerId,
        patients: selectedPatientList,
      };
      if (!payload) return;
      const response = await assignPatientProvider(payload);
      if (response.status !== 200) {
        showToastError("Error while updating");
        return;
      }

      await getAllProviders();
      showToastSuccess("Care team Assigned Successfully");
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (e) => {
    let searchWord = e.target.value;
    const result = patientList.filter((value) => {
      if (value) {
        return value?.full_name
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
    });

    if (searchWord === "") {
      setFilterData(patientList);
      // getGroupLists(searchWord);
    } else {
      setFilterData(result);
    }
  };

  useEffect(() => {
    if (modalOpen) {
      getPatientsLists();
    }
  }, [modalOpen]);

  useEffect(() => {
    setProviderId(members);
    if (Object.keys(provider).length > 0) {
      setRemovePatientsModal(
        provider.assignPatients.map((patient) => patient.userId)
      );
    }
  }, [members]);

  return (
    <div
      className="modal fade"
      id="assignpatientproviders"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content px-4">
          <div className="modal-header px-4 border-0">
            <h5 className="modal-title">Assign Clients</h5>
            <button
              type="button"
              id="btn-close"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setModalOpen(false);
                setSelectedPatientList([]);
              }}
            ></button>
          </div>
          <div className="modal-body pt-4 pb-2 px-4 ">
            <div
              style={{
                marginTop: "-10px",
                display: "flex",
                justifyContent: "end",
                marginBottom: "10px",
                marginLeft: "-5px",
              }}
            >
              <div className="actsearch_box1">
                <FiSearch className="boxicon" />
                <input
                  placeholder="Search Here..."
                  className="ms-2"
                  onChange={(e) => onSearch(e)}
                />
              </div>
            </div>

            <div className="col-md-12 p-1">
              <div
                className="memlist_scroll mt-1 justify-content-center spacing_scroll"
                style={{ height: 300 }}
              >
                { filterdata?.length > 0 ? (
                  filterdata
                    .filter((dt1) => !removePatientsModal.includes(dt1._id))
                    .map((dt, index) => {
                      return (
                        <div
                          key={index}
                          // className={`card mb-2 p-1 ${index == 0 ? "active" : ""}`}
                          className={`card mb-2 py-2 px-3`}
                          style={{ background: "#F2F4F6" }}
                          onClick={() => {}}
                          id={dt._id}
                        >
                          <div className="btn-group  align-items-center gap-2">
                            <p className="affir_checkbox mb-0">
                              <input
                                type="checkbox"
                                name="members"
                                value={dt._id}
                                id="flexCheckDefault"
                                checked={selectedPatientList?.includes(dt._id)}
                                onChange={(e) =>
                                  UpdateGroup(e.target.checked, e.target.value)
                                }
                              />
                            </p>
                            <div className=" actlist_wid2 ms-2 d-flex gap-2 align-items-center">
                              <SquareAvatar
                                src={
                                  !urlPattern.test(dt?.profilePicture)
                                    ? `${ApiConfig.ImageUrl}user/${dt?._id}/${dt?.profilePicture}`
                                    : dt?.profilePicture
                                }
                                className="member_listimage round_image2"
                              />
                              <p className="py-0 mb-0">
                              {(dt?.full_name?.trim("")) ? dt?.full_name !== "undefined undefined" ? dt?.full_name : 'Anonymous' : 'Anonymous'}
                              </p>
                            </div>
                          </div>
                          {/* <div className="table_resouter card bg-light p-2 my-2">
                                                        <table className="table mb-0 table-borderless table_resinner4">
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={2}><span className="fw-bold">Qualifications: </span> 
                                                                    {Array.isArray(dt.qualifications)
                                                                    ? dt?.qualifications.length > 0
                                                                        ? dt.qualifications.map((item, idx, arr) => {
                                                                        return (
                                                                            <Fragment key={idx}>
                                                                            {item.name}
                                                                            {arr.length - 1 == idx ? "" : ", "}
                                                                            </Fragment>
                                                                        );
                                                                        })
                                                                        : "N/A"
                                                                    : dt.qualifications}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='text-capitalize'><span className="fw-bold">Category:</span> {dt.docCategory}</td>
                                                                    <td><span className="fw-bold">Year of experience:</span>  {dt.yearsOfExperience}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div> */}
                        </div>
                      );
                    })
                ) : (
                  <Loader
                  visible={isLoading}
                  emptyTextKey={filterdata.length > 0 ? '' :  'noPatient'}
                  style={{ top: 0, position: "relative" }} />
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer px-3 border-0 mb-3">
            <button
              type="button"
              onClick={() => {
                updateGroup();
                setModalOpen(false);
                setSelectedPatientList([]);
              }}
              data-bs-dismiss="modal"
              // disabled={check===0}
              className="description_btnsave w-100"
              style={{
                backgroundColor: "#1f7e78",
                borderColor: "#1f7e78",
              }}
            >
              {"Assign"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignPatientProviderModal;
